import Vue from 'vue'

// Trail for the top bar (beside the user avatar). The v2 micro-app publishes
// it through the qiankun global state; host routes have none.
export const hostBreadcrumb = Vue.observable({ items: [] })
